'use strict';

export class Accordion {
	constructor(component_id) {
		this.id = component_id;
	}

	init() {
		const id = this.id;
		const $root = jQuery('.js-' + id);

		$root.on('click', '.js-accordion_head', function() {
			const $head = jQuery(this);
			const $item = $head.closest('.js-accordion');

			if ($item.data('accordion-parent') !== id) return;

			const $body = $item.children('.js-accordion_body').first();

			if ($item.hasClass('active')) {
				$item.removeClass('active');
				$body.slideUp();
				return;
			}

			$root.find('.js-accordion.active[data-accordion-parent="' + id + '"]')
				.removeClass('active')
				.children('.js-accordion_body').slideUp();

			$item.addClass('active');
			$body.slideDown();
		});

		$root.find('.js-accordion_body').filter(function() {
			return jQuery(this).closest('.js-accordion').data('accordion-parent') === id;
		}).hide();
	}
}


const init_accordion = () => {
	if (typeof yalwa === 'undefined' || !yalwa.v || !yalwa.v.components) return;
	for (const key in yalwa.v.components) {
		if (key.startsWith('accordion_')) {
			new Accordion(key).init();
		}
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init_accordion);
} else {
	init_accordion();
}

// Deep link: expand matching question + all parent accordions
jQuery(function() {
	const hash = window.location.hash;
	if (!hash) return;
	const $link = jQuery('.accordion__link[href="' + hash + '"]');
	if (!$link.length) return;

	const $item = $link.closest('.js-accordion');

	// Expand parent accordion items up the tree
	$item.parents('.js-accordion').each(function() {
		jQuery(this).addClass('active').children('.js-accordion_body').slideDown();
	});

	// Expand the target item itself
	$item.addClass('active');
	$item.children('.js-accordion_body').slideDown();
});